<template>
  <div>
    <div class="panel-heading bg-color-skin">
      <div class="col-xs-2"></div>
      <div class="col-xs-8 align-center">
        <label> {{ nameCodapp }} </label>
      </div>
      <div class="col-xs-2 align-right" v-show="linkDisp" v-on:click="redirectToLeaveReq()" :title="tooltip">
          <i class="fa fa-plus-circle " aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { router } from 'src/router'

export default {
  name: 'calendar_header',
  props: {
    nameCodapp: {
      type: String,
      default: ''
    },
    linkToRedirect: {
      type: String,
      default: '#'
    },
    linkDisp: {
      type: Boolean,
      default: true
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  methods: {
    redirectToLeaveReq () {
      router.push({ name: this.linkToRedirect })
    }
  }
}
</script>


// WEBPACK FOOTER //
// calendar_header.vue?77c35437